'use client'

import React, { useEffect, useCallback } from 'react'
import { Message } from '@locmod/intl'
import cx from 'classnames'
import { Icon } from 'components/ui'

export type ToastType = 'success' | 'warning'

export type ToastProps = {
  message: string | Intl.Message
  type?: ToastType
  onClose: () => void
  className?: string
}

const Toast: React.FC<ToastProps> = ({
  message,
  type = 'info',
  onClose,
  className,
}) => {
  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  // useEffect(() => {
  //   const timer = setTimeout(handleClose, duration)
  //   return () => clearTimeout(timer)
  // }, [duration, handleClose])

  const iconMap: Record<ToastType, string> = {
    success: 'interface/accepted_fill',
    warning: 'interface/warning',
  }

  const iconColorMap: Record<ToastType, string> = {
    success: 'text-[#00A27D]',
    warning: 'text-warning',
  }

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={cx(
        // 'fixed mb:top-14 mb:left-0 ds:bottom-5 ds:right-4 z-[1001] flex items-center gap-1.5 h-10 px-4 rounded-sm shadow-lg mx-4 mb:w-11/12 ds:min-w-[299px] ds:max-w-[299px] bg-accent-grey-800 overflow-hidden animate-toast-enter',
        'bg-accent-grey-800 relative w-full h-10 flex items-center gap-1.5 rounded-sm shadow-lg px-4 overflow-hidden',
        className
      )}
    >
      <Icon
        name={iconMap[type]}
        className={cx('h-[17px] w-[17px]', iconColorMap[type])}
        aria-hidden="true"
      />
      <Message
        value={message}
        className="text-white text-[12px] font-medium flex-1"
      />
      <button
        onClick={handleClose}
        className="text-white transition-colors hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-white rounded"
        aria-label="Close notification"
      >
        <Icon
          name="interface/close"
          className="w-[14px] h-[14px]"
          aria-hidden="true"
        />
      </button>

      <div className="absolute bottom-0 left-0 h-[1px] w-full bg-white">
        <div
          className="h-full bg-brand-light-500"
          style={{
            animation: 'toast-timer 5000ms linear forwards',
            width: '100%',
          }}
        />
      </div>
    </div>
  )
}

export default Toast
